import * as React from 'react';

import {Button} from 'shells/button/button';

import {appHistory} from '../../../../history';

type Props = {
    isSearching: boolean;
    canManageEmailTemplates: boolean;
    onCloseModal: () => void;
    setSearchValue: (value: string) => void;
};

export function EmptyState(props: Props) {
    const firstLineText = props.isSearching ? 'No emails matching your search' : 'No emails';
    const includeCTA = props.isSearching || props.canManageEmailTemplates;
    const handleClick = () => {
        if (props.isSearching) {
            props.setSearchValue('');
        } else {
            props.onCloseModal();
            appHistory.push('/email/templates');
        }
    };
    const buttonText = props.isSearching ? 'Clear search' : 'See all templates';

    return (
        <div className='pad-16 flex flex-dir-col align-center justify-center'>
            <strong>{firstLineText}</strong>
            {includeCTA ? (
                <Button variant='text-primary' onClick={handleClick}>
                    {buttonText}
                </Button>
            ) : undefined}
        </div>
    );
}
